import { InputLabel, Grid, FormHelperText, Button } from '@material-ui/core';
import './loanStyle.scss';
import { DatePicker, SecondaryButton, SingelSelect, TextBox } from '../../../Core/FormInput';
import { useContext, useEffect, useState } from 'react';
import { LoanVehicleContext } from './loanVehicle-provider';
import { SingleSelectConditionBased } from '../../../Core/FormInput/MultiSelect';
function LoanVehicleDetails() {
    const { vehicleDetails, handleVehicleDetails, errors, state, singleSelectChange, createNewLVU, isInSignatureCompleted } = useContext(LoanVehicleContext);

    return (
        <Grid container spacing={1} className="mainSection">
            <Grid item xs={12}>
                <Grid container>
                    <Grid item xs={6} md={6} lg={6}>
                        <div className="Loan_Veh_heading">Loan Vehicle Details </div>
                    </Grid>
                    {isInSignatureCompleted && (
                        <Grid item xs={6} md={6} lg={6} style={{ textAlign: 'right' }}>
                            <SecondaryButton onClick={createNewLVU}>Use Another Vehicle</SecondaryButton>
                        </Grid>
                    )}
                </Grid>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={3}>
                <InputLabel shrink error required>
                    Loan Vehicle Reg
                </InputLabel>
                <SingleSelectConditionBased onChange={singleSelectChange} options={vehicleDetails.tempLoanVehicle || []} value={state.regNumberValue} />
                {errors.vehicleReg && <FormHelperText error>{errors.vehicleReg}</FormHelperText>}
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={3}>
                <InputLabel shrink error required>
                    Vehicle model
                </InputLabel>
                <TextBox name="vehicleModel" value={vehicleDetails.vehicleModel} onChange={handleVehicleDetails} disabled={state.isVehicleReceived} />
                {errors.vehicleModel && <FormHelperText error>{errors.vehicleModel}</FormHelperText>}
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={3}>
                <InputLabel shrink>Insurance Value</InputLabel>
                <TextBox name="insuranceValue" value={vehicleDetails.insuranceValue} onChange={handleVehicleDetails} disabled={state.isVehicleReceived} />
                {/* {errors.insuranceValue && <FormHelperText error>{errors.insuranceValue}</FormHelperText>} */}
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={3}>
                <InputLabel shrink style={{ marginBottom: '8px' }} error required>
                    Date
                </InputLabel>
                <DatePicker name="dateCreated" value={vehicleDetails.dateCreated} onChange={handleVehicleDetails} disabled={state.isVehicleReceived} />
                {errors.dateCreated && <FormHelperText error>{errors.dateCreated}</FormHelperText>}
            </Grid>
        </Grid>
    );
}

export default LoanVehicleDetails;
